import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../util/utils';
import SelectDropdown from '../../SelectDropdown/SelectDropdown';
import TextInput from '../../TextInput/TextInput';
import Button from '../../BaseComponentWrappers/MotifButton';
import DeleteAccountModal from '../DeleteAccountModal/DeleteAccountModal';
import EllipsesControl from '../../EllipsesControl/EllipsesControl';
import {cleanAccount} from '../../../../actions/Account/accountactions';
import _ from 'lodash';

function EditAccountHeaderModal(props) {
	const [accountLabel, setAccountLabel] = useState('');
	const [inputAccountName, setInputAccountName] = useState('');
	const [selectedAccount, setSelectedAccount] = useState({});
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const dispatch = useDispatch();

	const displayAccountNameError = props.showErrors && (!inputAccountName || inputAccountName?.trim() === '');

	useEffect(() => {
		changeAccountLabel({});
	}, []);
	const deleteMotifDisabled = () => {
		document
			.getElementById('inputWrapper')
			.getElementsByTagName('label')[0]
			.classList.remove('motif-disabled');
	};

	useEffect(() => {
		if (!_.isEmpty(props.editAccount) > 0) {
			setInputAccountName(props.editAccount.accountName);
			deleteMotifDisabled();
			if (Object.keys(selectedAccount).length === 0 || (!selectedAccount?.value && !props.createNewAccount)) {
				setSelectedAccount({value: props.editAccount.id, label: props.editAccount.accountName});
				setAccountLabel(labels.accountLabel);
			}
		} else {
			setInputAccountName('');
			setSelectedAccount({});
			setAccountLabel(labels.selectAnAccountLabel);
		}
	}, [props.editAccount]);

	const handlerOnSelectAccountChange = (item) => {
		if (!props.changesWithoutSave) {
			props.setCreateNewAccount(false);
			setSelectedAccount(item);
			changeAccountLabel(item);
			setInputAccountName(item.label);

			if (props.handlerOnSelectAccountChange) {
				props.handlerOnSelectAccountChange(item);
			}
		} else {
			props.setShowSureModal(true);
			props.setNextAccount(item);
		}
	};

	const handlerOnAccountNameChange = (e) => {
		setInputAccountName(e.target.value);
		if (props.handlerOnAccountNameChange) {
			props.handlerOnAccountNameChange({accountName: e.target.value});
		}
	};

	const changeAccountLabel = (itemSelected) => {
		setAccountLabel(Object.keys(itemSelected).length > 0 ? labels.accountLabel : labels.selectAnAccountLabel);
	};

	const handleOnClickDeleteAccountLink = () => {
		if (selectedAccount.value) {
			setShowDeleteModal(true);
		}
	};

	const onCloseDeleteModal = () => {
		setShowDeleteModal(false);
	};

	const formatItem = (props) => {
		const option = <EllipsesControl content={props.label} tooltip={props.label} noOfLines={1} />;
		return option;
	};
	const footer = (
		<section className="createaccount-wrapper">
			<Button
				className="create-account"
				variant="text-alt"
				onClick={() => {
					document.activeElement.blur();
					dispatch(cleanAccount()).then(() => document.getElementById('accountname-input').focus());
					props.setCreateNewAccount(true);
					deleteMotifDisabled();
					return false;
				}}
				showLabel
				buttonLabel={labels.createNewAccount}
			/>
		</section>
	);

	return (
		<>
			<StyledEditAccountHeaderModal className="StyledEditAccountHeaderModal" textDisabled={false}>
				<section className="SelectAccountWrapper">
					<SelectDropdown
						key={'SelectAccountDropdownKey'}
						id={'SelectAccountDropdownId'}
						className={'accounts-dropdown'}
						name={'SelectAccountDropdown'}
						value={
							props.createNewAccount
								? {label: labels.createNewAccount, value: -1}
								: props.editAccount && {value: props.editAccount.id, label: props.editAccount.accountName}
						}
						formLabel={accountLabel}
						options={props.accountsList}
						onChange={handlerOnSelectAccountChange}
						hideSelectedOptions={false}
						formatOptionLabel={formatItem}
						footer={footer}
						onLabelClickSetFocus={false}
						// blurInputOnSelect
					/>
					{props.editAccount && props.editAccount.accountName && !props.createNewAccount && (
						<Button
							variant="text-alt"
							onClick={handleOnClickDeleteAccountLink}
							className="delete-account"
							showLabel
							buttonLabel={labels.deleteAccount}
						/>
					)}
				</section>
				<section id="inputWrapper">
					<TextInput
						id="accountname-input"
						inputVal={inputAccountName}
						label={labels.accountNameLabel}
						wrapperClass="accountname-input"
						maxLength={500}
						onInputChange={handlerOnAccountNameChange}
						errormessage={labels.requiredAccountName}
						showinputerror={displayAccountNameError}
						disabled={!inputAccountName && !props.createNewAccount && _.isEmpty(props.editAccount)}
					/>
				</section>
			</StyledEditAccountHeaderModal>
			{showDeleteModal && (
				<DeleteAccountModal
					show={showDeleteModal}
					onClose={onCloseDeleteModal}
					hideEditAccountModal={props.hideEditAccountModal}
					account={selectedAccount}
					callFrom={props.callFrom}
					isAresView={props.isAresView}
					setToasterLabel={props.setToasterLabel}
					setToasterVisible={props.setToasterVisible}
				/>
			)}
		</>
	);
}

export default EditAccountHeaderModal;

const StyledEditAccountHeaderModal = styled.section`
	margin: 0 var(--px-20) 0 0;
	border-bottom: var(--px-1) solid var(--neutrals-300);
	.SelectAccountWrapper {
		display: flex;
		align-items: center;
		margin-bottom: var(--px-30);
		width: 63.1%;
		@media only screen and (min-width: 1280px) and (max-width: 1367px) {
			width: 65.1%;
		}
		.accounts-dropdown {
			width: calc(100% - var(--px-200));
			margin-right: var(--px-30);
			&.select-disabled {
				cursor: default;
			}
			.react-select-container {
				.react-select__control {
					.react-select__single-value {
						padding-top: var(--px-20) !important;
					}
					.react-select__value-container:not(.react-select__value-container--is-multi) > div .react-select__input {
						padding-top: var(--px-10) !important;
					}
				}
			}
			.createaccount-wrapper {
				display: flex;
				padding: var(--px-12) var(--px-10);
				width: 100%;
				border-top: var(--px-1) solid var(--neutrals-700);
				.create-account {
					display: flex;
					font-size: var(--px-14);
					border-bottom: 0 !important;
					color: var(--blue-600);
					&:hover {
						border-bottom: var(--px-1) solid var(--blue-600) !important;
					}
					&:focus {
						box-shadow: none;
						border-bottom: var(--px-1) solid var(--blue-600) !important;
					}
				}
			}
		}
		.delete-account {
			margin-left: auto;
			display: inline-flex;
			font-size: var(--px-14);
			width: auto;
			max-width: var(--px-200);
			&:focus,
			&:hover {
				box-shadow: none;
				border: none;
				text-decoration: none;
			}
			span:hover {
				border-bottom: var(--px-1) solid var(--blue-600) !important;
			}
		}
	}
	.accountname-input {
		margin-bottom: var(--px-40);
		width: 63.1%;
		@media only screen and (min-width: 1280px) and (max-width: 1367px) {
			width: 65.1%;
		}
		.motif-input-component {
			.motif-input {
				width: 100%;
				height: var(--px-46);
			}
		}
	}
`;
